import { useState, useEffect } from 'react'
import toast from 'react-hot-toast'
import { expenseApi } from '../services/api'

/**
 * Fetches a receipt with the auth header and hands back an object URL for
 * ReceiptViewer to render.
 *
 * A plain <a href> to the receipt endpoint does not work: it is [Authorize] and
 * a browser navigation carries no Authorization header, so it comes back 401.
 */
export function useReceiptViewer() {
    const [receipt, setReceipt] = useState(null)
    const [loadingId, setLoadingId] = useState(null)

    // Object URLs are held until revoked, and someone reviewing a month may open
    // a lot of them. Cleanup runs on replace and on unmount.
    useEffect(() => {
        return () => { if (receipt?.url) URL.revokeObjectURL(receipt.url) }
    }, [receipt])

    async function open(expense) {
        setLoadingId(expense.uuid)
        try {
            const fetched = await expenseApi.fetchReceipt(expense.uuid)
            setReceipt({ ...fetched, label: `${expense.vendor} · ${expense.expenseDate}` })
        } catch (error) {
            toast.error(error.message || 'Could not load the receipt')
        }
        setLoadingId(null)
    }

    function close() {
        setReceipt(null)   // the effect cleanup revokes the URL
    }

    return { receipt, loadingId, open, close }
}
